import { AppConfigModel } from "../abstract/app-config.model";

export class DocumentEmailType extends AppConfigModel {

    static override CLASS_NAME: string = 'DocumentEmailType';
}
